<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-28 21:49:27
-->
<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div class="search-div common-section-bg">
      <div class="shaixuan-item">
        <el-select v-model="queryParam.city" clearable filterable placeholder="请选择城市">
          <el-option v-for="item in optionList" :key="item.id" :label="item.name" :value="item.name" />
        </el-select>
      </div>
      <div class="shaixuan-item">
        <el-input v-model="queryParam.name" size="mini" clearable placeholder="请输入小区名称查找" />
      </div>
      <div class="shaixuan-item">
        <el-button type="primary" size="mini" style=" background: #1067e0;border-color: #1067e0;" @click="searchClick()"
          icon="el-icon-search">
          查询
        </el-button>
        <el-button type="primary" icon="el-icon-refresh" @click="syncData">
          同步
        </el-button>
        <!-- <el-button @click="clickItemImport()"
                   type="primary"
                   size="mini"
                   icon="el-icon-plus">
          车场数据录入
        </el-button> -->
      </div>
    </div>
    <!-- 列表展示 -->
    <div class="common-section-bg common-section-body">
      <el-table v-loading="listLoading" :data="tableData" size="mini" style="width: 100%; min-height: 300px">
        <el-table-column prop="id" label="id" width="180" />
        <el-table-column prop="city" label="市" minWidth="200" />
        <el-table-column prop="commName" label="小区" minWidth="200" />
        <el-table-column prop="first_word" label="小区首字母" width="80" />
        <el-table-column prop="phone" label="物业电话" width="200" />
        <!-- <el-table-column prop="hk_ip" label="海康IP" width="200" /> -->
        <el-table-column fixed="right" align="center" label="操作" width="500">
          <template slot-scope="scope">
            <el-button type="danger" style=" background: #42d885;border-color: #42d885; " size="mini" @click="clickItem(1, scope.row)">修改</el-button>
            <el-button type="danger" style="  background: #1067e0;   border-color: #1067e0;  " size="mini" @click="ResourceClick(scope.row)">小区资源</el-button>
            <el-button type="danger" style=" background: #FEC171; border-color: #FEC171; " size="mini" @click="guanjiaClick(scope.row)">管家</el-button>
            <el-button type="success" size="mini" @click="showPriv(scope.row.id)">权限</el-button>
            <el-button type="warning" size="mini" @click="synchaikang(scope.row.id)">同步海康</el-button>
            <el-button type="warning" size="mini" style=" background: #42d885;border-color: #42d885;" @click="clickItemtishi(scope.row)">装修提示</el-button>

            <!-- <el-button type="danger"
                       @click="remove(scope.row)"
                       size="mini">删除</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination v-show="total" :total="total" :page.sync="queryParam.page" :limit.sync="queryParam.size"
        @pagination="getList" />
    </div>
    <el-drawer custom-class="custom-drawer" :visible.sync="showDrawer" :close-on-press-escape="false"
      :wrapper-closable="false" :show-close="false" size="50%">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
          <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
        </div>
      </template>
      <div class="custom-content">
        <RoleAdd ref="RoleAdd" @onUpdateDrawer="onUpdateDrawer($event)" />
      </div>
    </el-drawer>
    <!-- 温馨提示-->
     <el-drawer custom-class="custom-drawer" :visible.sync="showDrawertishi" :close-on-press-escape="false"
      :wrapper-closable="false" :show-close="false" size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name"> {{this.tishimodel.commName}}:装修提示</div>
          <i class="el-icon-circle-close close-btn pointer" @click="showDrawertishi= false;" />
        </div>
      </template>
      <div class="custom-content" style="padding-left: 30px;">
        <el-input
            v-model="tishimodel.tishi.tishi"
            :autosize="{ minRows: 4, maxRows: 15}"
            type="textarea"
            placeholder="装修提示"
          />
      </div>
      <el-button type="success" style="float: right;margin-right: 30px;" @click="edittishi">确定</el-button>
    </el-drawer>

  <!-- 导入数据-->
     <el-drawer custom-class="custom-drawer" :visible.sync="showDrawerImport" :close-on-press-escape="false"
      :wrapper-closable="false" :show-close="false" size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name"> 数据导入</div>
          <i class="el-icon-circle-close close-btn pointer" @click="showDrawertishi= false;" />
        </div>
      </template>
      <div class="custom-content" style="padding-left: 30px;">
        <image-video ref="ImageVideo"
                    :tipInfo="`上传式为'xls,xlxs'`"
                    :image-list="videoDefaultList" :maxNumber="1" @updateImg="onUpdateVideo($event)"></image-video>
      </div>
      <el-button type="success" style="float: right;margin-right: 30px;" @click="importexcel()">确定</el-button>
    </el-drawer>


    <el-drawer custom-class="custom-drawer" :visible.sync="showPrivDrawer" :close-on-press-escape="false"
      :wrapper-closable="false" :show-close="false" size="532px">
      <template slot="title">
        <div class="custom-title">
          <div class="title-name">权限配置</div>
          <i class="el-icon-circle-close close-btn pointer" @click="showPrivDrawer = false" />
        </div>
      </template>
      <div class="custom-content">
        <el-table v-loading="privlistLoading" :data="privtableData" size="mini" style="width: 100%; min-height: 300px">
          <el-table-column prop="priv" label="权限名称" width="200" />
          <el-table-column prop="admin" label="开关">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="1"
                :inactive-value="0" @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import Cookies from "js-cookie";
import fetch from "@/api/tianzheng/Qu";
import city from '@/api/tianzheng/city'
import RoleAdd from "./QuAdd.vue";
import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
// import ImageVideo from "@/components/UploadVideo/index";
export default {
  data() {
    return {
      privtableData: [],
      privlistLoading: true,
      showPrivDrawer: false,
      showDrawerImport:false,
      videoDefaultList:[],
      pageLoading: '',
      optionList: [],
      queryParam: {
        name: "",
        page: 1,
        size: 10,
      },
      total: 0,
      listLoading: false,
      tableData: [],
      isEdit: 0, // 0新增 1编辑
      showDrawer: false,
      showDrawertishi:false,
      id: null,
      tishimodel:{id:null,tishi:{tishi:""}}
    };
  },
  components: {
    Pagination,
    RoleAdd,
    // ImageVideo,
  },
  created() {
  },
  mounted() {
    this.getList();
    this.getSelectCity();
  },
  methods: {
    importexcel(){
      if(this.videoList.length !=1){
        this.$message.error("文件数量不正确");
        return;
      }
        fetch.importexcel({'filepath':this.videoList[0]}).then((res) => {
            if (res.code == 200) {
                console.log(1);
            }else{
                console.log(2);
            }
        })
    },
    onUpdateVideo(val) {
          let videoList = [];
          val.forEach((ele, idx) => {
              videoList.push(ele.path);
          });
          this.videoList = videoList;
    },
    showPriv(id) {
      this.showPrivDrawer = true;
      this.privlistLoading = true;
      this.id = id;
      fetch.priv({ id: id }).then((res) => {
        this.privlistLoading = false;
        if (res.code == 200) {
          this.$message.success(res.message)
          this.privtableData = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    ResourceClick(row) {
      console.log(row.id)
      this.$router.push({
        path: '/resourceManage/ResourceList?id=' + row.id
      })
    },
    guanjiaClick(row) {
      console.log(row.id)
      this.$router.push({
        path: '/resourceManage/GuanjiaList?id=' + row.id
      })
    },
    // 获取下拉列表
    getSelectCity() {
      city.select({}).then(res => {
        if (res.code == 200) {
          this.optionList = res.result;
        }
      })
    },
    // 同步数据
    syncData() {
      const that = this
      that.$confirm('确定同步小区信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 调用接口
          that.pageLoading = Loading.service({
            lock: true,   //是否锁定屏幕的滚动
            text: "加载中……",  //loading下面的文字
            background: "rgba(0, 0, 0, 0.7)",  //loading的背景色
            target: "body"      //loading显示在容器
          });
          fetch.sync({}).then((res) => {
            that.pageLoading.close();
            that.pageLoading = null;
            if (res.code == 200) {
              that.$message.success(res.message)
              that.getList()
            } else {
              that.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          that.pageLoading.close();
          that.pageLoading = null;
        })
    },
    synchaikang(id) {
      const that = this
      that.$confirm('确定同步小区海康房屋信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          // 调用接口
          that.pageLoading = Loading.service({
            lock: true,   //是否锁定屏幕的滚动
            text: "加载中……",  //loading下面的文字
            background: "rgba(0, 0, 0, 0.7)",  //loading的背景色
            target: "body"      //loading显示在容器
          });
          fetch.syncHik({ id: id }).then((res) => {
            that.pageLoading.close();
            that.pageLoading = null;
            if (res.code == 200) {
              that.$message.success(res.message)
              that.getList()
            } else {
              that.$message.error(res.message)
            }
          })
        })
        .catch(() => {
          that.pageLoading.close();
          that.pageLoading = null;
        })
    },
    /**
 * @name: 更改状态
 * @param {*} val
 * @return {*}
 * @desc:
 */
    changeStatus(val) {
      let params = {
        id: val.id,
        status: val.status
      };
      fetch.editpriv(params).then(res => {
        if (res.code == 200) {
          this.privlistLoading = true;
          fetch.priv({ id: this.id }).then((res) => {
            this.privlistLoading = false;
            if (res.code == 200) {
              this.$message.success(res.message)
              this.privtableData = res.result
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 更新弹层状态
    onUpdateDrawer(status) {
      console.log("status", status);
      if (status == 1) {
        // 成功
        this.showDrawer = false;
        this.getList();
      } else if (status == -1) {
        // 失败
        this.showDrawer = false;
      }
    },
    /**
     * @name: 关闭弹层
     * @return {*}
     * @desc:
     */
    closeDrawerFun() {
      this.showDrawer = false;
      this.$refs.RoleAdd.resetForm();
    },
    // clickItemImport(){
    //   this.showDrawerImport = true;
    //   this.videoDefaultList = [];
    //   if(this.$refs.ImageVideo){
    //       this.$refs.ImageVideo.clearFileList();
    //   }
    // },
    /**
     * @name: 点击子项 0新增 1编辑
     * @param {*} type
     * @param {*} id
     * @return {*}
     * @desc:
     */
    clickItem(type, row) {
      let that = this;
      this.showDrawer = true;
      this.isEdit = type;
      // 给组件传值
      let obj = {
        type: type,
        id: row ? row.id : "",
      };
      this.$nextTick(function () {
        that.$refs.RoleAdd.initFun(obj);
      });
    },
    /* 装修提示 */
    clickItemtishi(row){
      let that = this;
      this.showDrawertishi =  true;
      this.tishimodel = row;
      if(this.tishimodel.tishi == null){
        this.tishimodel.tishi ={
          id:0,
          com_id:this.tishimodel.id,
          tishi:"",
        }
      }
    },
    /*提交提示 */
    edittishi(){
      let that = this;
      fetch.edittishi(this.tishimodel.tishi).then((res) => {
        that.listLoading = false;
        that.showDrawertishi = false;
        this.getList();
      });
    },
    /* 查询按钮，页码重置，查询数据 */
    searchClick() {
      this.queryParam.page = 1;
      this.getList();
    },
    /* 查询tableData数据 */
    getList() {
      let that = this;
      this.listLoading = true;
      fetch.list(that.queryParam).then((res) => {
        that.listLoading = false;
        that.tableData = res.result.list;
        that.total = res.result.total;
      });
    },
    remove(row) {
      let that = this;
      that.$confirm("确定删除该内容吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 调用接口
          fetch.remove({ role_id: row.id }).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.message);
              that.getList();
            } else {
              that.$message.error(res.message);
            }
          });
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  min-height: calc(100vh - 98px);
}
</style>
